import { render, staticRenderFns } from "./premium-creative-config-modal.vue?vue&type=template&id=54c93f32&scoped=true"
import script from "./premium-creative-config-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./premium-creative-config-modal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./premium-creative-config-modal.vue?vue&type=style&index=0&id=54c93f32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c93f32",
  null
  
)

export default component.exports